type MapWithValue<K, V> = {
	get(specific_key: K): V
} & Map<K, V>

export default <MAP_KEY, MAP_VALUE, SPECIFIC_KEY extends MAP_KEY>(map: Map<MAP_KEY, MAP_VALUE>, key: SPECIFIC_KEY): map is MapWithValue<SPECIFIC_KEY, MAP_VALUE> => map.has(key)
